import Marquee from "./Marquee";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "@/config";

const FORMATS = [
  "Video Advertisements", "Social Content", "Retargeting Ads", "Brand Films",
  "Testimonials", "Educational Content", "Promotional Campaigns",
];

export default function Creative() {
  return (
    <section id="creative" data-testid="creative-section" className="border-t border-line">
      <Marquee items={["Strategy", "Creative", "Advertising", "Technology", "Automation"]} />

      <div className="px-6 py-28 md:px-12 md:py-40">
        <div className="mx-auto grid max-w-[1600px] gap-16 lg:grid-cols-2">
          <div>
            <Reveal><Overline>05 — Content + Advertising</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white md:text-5xl">
                Creative built <span className="text-zinc-500">to perform</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-lg text-base leading-relaxed text-zinc-400 md:text-lg">
                Beautiful content isn&rsquo;t enough. TPA develops creative around a business
                objective. The goal isn&rsquo;t views, likes, or impressions — it&rsquo;s moving
                the right audience toward action.
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <ul className="mt-12 grid grid-cols-1 gap-px bg-line sm:grid-cols-2">
                {FORMATS.map((f) => (
                  <li
                    key={f}
                    data-testid={`creative-format-${f.toLowerCase().replace(/\s+/g, "-")}`}
                    className="group flex items-center justify-between bg-obsidian px-6 py-5 transition-colors duration-500 hover:bg-white/[0.04]"
                  >
                    <span className="font-display text-sm font-bold uppercase tracking-wide text-zinc-300 transition-colors duration-300 group-hover:text-white">{f}</span>
                    <span className="h-1 w-1 bg-zinc-700 transition-colors duration-300 group-hover:bg-crimson" />
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          <Reveal delay={0.15} className="relative hidden lg:block">
            <div className="relative h-full min-h-[520px]">
              <div
                className="absolute left-0 top-0 h-[62%] w-[78%] overflow-hidden border border-line"
                style={{ clipPath: "polygon(0 0, 100% 0, 100% 88%, 88% 100%, 0 100%)" }}
              >
                <img src={IMAGES.office} alt="Campaign strategy session" className="h-full w-full object-cover grayscale transition-transform duration-700 hover:scale-105" />
                <div className="absolute inset-0 bg-black/40" />
              </div>
              <div
                className="absolute bottom-0 right-0 h-[48%] w-[55%] overflow-hidden border border-line"
                style={{ clipPath: "polygon(12% 0, 100% 0, 100% 100%, 0 100%, 0 12%)" }}
              >
                <img src={IMAGES.stairs} alt="Growth systems architecture" className="h-full w-full object-cover grayscale transition-transform duration-700 hover:scale-105" />
                <div className="absolute inset-0 bg-black/40" />
              </div>
              <p className="absolute -bottom-2 left-0 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600">
                Campaign Creative / Brand Film / Paid Media
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
